import { type PexelsImage } from '@/views/build/hook/imageSearch/useImageSearch';
import { PexelsInfiniteListView } from './PexelsInfiniteListView';
export const SearchedImagesScreen = ({
  images,
  isLoadingMore,
  hasNextPage,
  onImageSelect,
  onLoadMore
}: {
  images: PexelsImage[];
  isLoadingMore: boolean;
  hasNextPage: boolean;
  onImageSelect: (imageUrl: string) => void;
  onLoadMore: () => void;
}) => {
  return <PexelsInfiniteListView images={images} hasNextPage={hasNextPage} onLoadMore={onLoadMore} onImageSelect={onImageSelect} isLoadingMore={isLoadingMore} data-sentry-element="PexelsInfiniteListView" data-sentry-component="SearchedImagesScreen" data-sentry-source-file="SearchedImagesScreen.tsx" />;
};